import React from "react";

/**
 * Shared progress bar.
 * - `segmented`: array of "done" | "active" | "pending" — one block per question.
 * - `value`: 0..1 continuous fill (used when `segmented` is omitted).
 * Fills inline-start -> inline-end via a row flex track, so it mirrors for
 * free under `dir="rtl"` — no left/right math needed.
 *
 * Defaults to white-on-white/30 (for colored game/dark chrome). Pass
 * `fillColor`/`trackColor` (any CSS color) for light-background screens
 * (reports, admin, trophy room) instead of white — no need to wrap this
 * component in an extra frame to fake a colored bar.
 */
export default function ProgressBar({
  segmented,
  value = 0,
  className = "",
  trackClassName = "",
  fillColor = "#fff",
  trackColor = "rgba(255,255,255,.3)",
}) {
  if (Array.isArray(segmented)) {
    return (
      <div className={`flex gap-1 w-full ${className}`}>
        {segmented.map((state, i) => (
          <div
            key={i}
            className="flex-1 h-2 rounded-full transition-colors"
            style={{ background: state === "pending" ? trackColor : fillColor }}
          />
        ))}
      </div>
    );
  }

  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <div
      className={`relative w-full h-2 rounded-full flex ${trackClassName} ${className}`}
      style={{ background: trackColor }}
    >
      <div
        className="h-full rounded-full transition-all duration-300"
        style={{ width: `${pct}%`, background: fillColor }}
      />
    </div>
  );
}
